<template>
    <div class="card">
        <Toast />
        <form>
            <div class="p-grid p-fluid">
                <div class="p-col-12">
                    <h5>{{ $t('Service.Edit.Header') }}</h5>
                    <div class="p-grid p-formgrid p-mb-3">
                        <div class="p-col-12 p-mb-2 p-lg-3 p-mb-lg-0 p-field">
                            <label for="title2">{{ $t('Service.Edit.Title') }}</label>
                            <InputText type="text" :placeholder="$t('Service.Edit.Title')" id="title2" v-model="mydata.title" disabled="disabled"></InputText>
                        </div>
                    </div>
                </div>
                <div class="p-col-12">
                    <div class="textbox" :style="error?.information_description ? 'border: 1px solid red' : ''">
                        <RichEditor v-model="information_description" :set-content="mydata.content" data-placeholder="$t('Service.Edit.Desc')" />
                    </div>
                    <div class="text-red">{{ error.information_description }}</div>
                    <!-- <Editor v-model="information_description" editorStyle="height: 320px" placeholder="Edit your data..."/> -->
                </div>
            </div>
            <br /><br />
            <div class="p-d-flex p-jc-end p-ai-center" style="float: left">
                <ConfirmPopup group="popup"></ConfirmPopup>
                <Button :label="$t('Service.Edit.Save')" iconPos="left" class="p-button1 p-button p-mr-2 p-mb-2" @click="confirm($event)" icon="pi pi-check" id="Save"></Button>
            </div>
            <div class="p-d-flex p-jc-end p-ai-center" style="float: right">
                <Button :label="$t('Service.Edit.Back')" icon="pi pi-replay" iconPos="left" class="p-button p-button-outlined p-button p-mr-2 p-mb-2" @click="$router.go(-1)" style="background: white; color: black"> </Button>
            </div>
            <br /><br />
        </form>
    </div>
</template>
<script>
// import validateEditUser from '../../validations/user/validateEditUser';
import ValidateEditService from '../../validations/ServiceTerms/ValidateEditService';
import ServiceTerms from '../../service/API/ServiceTerms';
import RichEditor from '../../components/RichEditor.vue';
import moment from 'moment';
export default {
    name: 'Edit Service',
    components: {
        RichEditor,
    },
    data() {
        return {
            blankData: '',
            errorText: false,
            dropdownValues: [{ name: 'active' }, { name: 'inactive' }],
            dropdownItem: null,
            // content: JSON.parse(localStorage.getItem('desc')).content,

            mydata: {
                update_key: '',
                title: '',
                content: '',
            },
            information_description: '',
            error: {},
        };
    },
    created() {
        this.serviceTerms = new ServiceTerms();
    },
    methods: {
        open() {
            this.display = true;
        },
        close() {
            this.display = false;
        },
        cancel() {
            // this.$toast.add({ severity: 'error', summary: 'Rejected', detail: 'You have rejected', life: 3000 });
            setTimeout(() => {
                this.$router.go(-1);
            }, 2000);
        },
        preventLeadingSpace(e) {
            // only prevent the keypress if the value is blank
            if (!e.target.value) e.preventDefault();
            // otherwise, if the leading character is a space, remove all leading white-space
            else if (e.target.value[0] == ' ') e.target.value = e.target.value.replace(/^\s*/, '');
        },
        // SubmitForm() {
        //     const visibleText = this.extractTextFromHTML(this.information_description);
        //     console.log(visibleText);
        // },
        confirm(event) {
            // confirm($event)
            // alert(this.mydata.notice_id)
            this.$confirm.require({
                target: event.currentTarget,
                group: 'popup',
                message: '진행하시겠습니까?',
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: '확인',
                rejectLabel: ' 취소',
                accept: () => {
                    // alert(this.extractTextFromHTML(this.information_description).trim());
                    console.log(this.blankData);
                    // this.blankData = this.mydata.content
                    let vcheckData = {
                        information_description: this.extractTextFromHTML(this.information_description).trim(),
                    };
                    const { isInvalid, error } = ValidateEditService(vcheckData);
                    if (isInvalid) {
                        this.error = error;
                        console.log(error);
                    } else {
                        this.error = '';
                        this.serviceTerms.editService({ update_key: this.$route.params.update_key, information_description: this.information_description }).then((res) => {
                            console.warn(res);
                            // localStorage.removeItem('information_description');
                            this.$router.push({ name: 'Service Terms' });
                            setTimeout(() => {
                                this.$toast.add({ severity: 'success', summary: '업데이트됨', detail: '서비스 약관이 업데이트되었습니다', life: 3000 });
                            }, 500);
                        });
                    }
                },
                reject: () => {
                    // this.$toast.add({ severity: 'error', summary: 'Rejected', detail: 'You have rejected', life: 3000 });
                },
            });
        },
        addDay(val) {
            const date = new Date(val);
            var dd = date.getDate();
            var mm = date.getMonth() + 1;
            var yyyy = date.getFullYear();
            if (dd < 10) {
                dd = '0' + dd;
            }
            if (mm < 10) {
                mm = '0' + mm;
            }
            return (val = yyyy + '.' + mm + '.' + dd);
        },
        dateformat(value) {
            if (value) {
                return moment(String(value)).format('YYYY/MM/DD');
            }
        },
        // Function to extract visible text from HTML
        extractTextFromHTML(html) {
            const element = document.createElement('div');
            element.innerHTML = html;

            // Recursive function to traverse the DOM tree
            function traverse(node, result = '') {
                const children = node.childNodes;

                for (let i = 0; i < children.length; i++) {
                    const child = children[i];

                    if (child.nodeType === Node.TEXT_NODE) {
                        result += child.textContent;
                    } else if (child.nodeType === Node.ELEMENT_NODE) {
                        if (child.style.display !== 'none') {
                            result += traverse(child);
                        }
                    }
                }

                return result;
            }

            return traverse(element);
        },
    },
    mounted() {
        this.serviceTerms.viewService(this.$route.params.update_key).then((result) => {
            this.mydata.title = result[0].title;
            this.mydata.content = result[0].content;
            this.information_description = result[0].content;
            // this.$refs.myQuillEditor.setHTML(result[0].content);
            // localStorage.setItem('desc', result[0].content);
            if (result[0].title === 'Location Based Information') {
                this.mydata.title = '위치기반 서비스 이용약관';
            } else if (result[0].title === 'Privacy Policy') {
                this.mydata.title = '개인정보 보호 정책';
            } else if (result[0].title === 'Seekers Terms & Conditions') {
                this.mydata.title = '개인회원 이용약관';
            } else if (result[0].title === 'Employer Terms & Conditions') {
                this.mydata.title = '기업회원 이용약관';
            }

            console.log(result);
        });
    },
};
</script>

<style scoped>
.p-fluid .p-button {
    width: auto;
}

input#title2 {
    background-color: lavender;
}

button.p-button.p-component.p-button1.p-button-sm.p-mr-2.p-mb-2 {
    background: black;
    color: white;
}

button.p-button.p-component.p-button-outlined.p-button-sm.p-mr-2.p-mb-2 {
    background: white;
    color: black;
    border: 1px solid;
}

.textbox {
    margin-top: -17px;
}

#Save {
    background: black;
    color: white;
}
</style>
